import { createContext, useContext, useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = localStorage.getItem("khn_token");
    if (!t) { setLoading(false); return; }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => { localStorage.removeItem("khn_token"); })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password, captcha_token = "", module = "bisnis") => {
    try {
      const { data } = await api.post("/auth/login", { email, password, captcha_token, module });
      try { localStorage.setItem("khn_module", module); } catch { /* ignore */ }
      localStorage.setItem("khn_token", data.token);
      localStorage.removeItem("khn_sa_token");
      try { sessionStorage.removeItem("khn_dismissed_reminders"); } catch { /* ignore */ }
      setUser(data.user);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiError(e) };
    }
  };

  // Super Admin "Masuk sebagai" user lain — token SA disimpan untuk kembali.
  const impersonate = (token) => {
    const cur = localStorage.getItem("khn_token");
    if (cur && !localStorage.getItem("khn_sa_token")) localStorage.setItem("khn_sa_token", cur);
    localStorage.setItem("khn_token", token);
    localStorage.removeItem("khn_pabrik");
    try { sessionStorage.removeItem("khn_dismissed_reminders"); } catch { /* ignore */ }
    window.location.assign("/");
  };

  const stopImpersonate = () => {
    const sa = localStorage.getItem("khn_sa_token");
    localStorage.removeItem("khn_sa_token");
    localStorage.removeItem("khn_pabrik");
    if (sa) { localStorage.setItem("khn_token", sa); window.location.assign("/superadmin/users"); }
    else { localStorage.removeItem("khn_token"); window.location.assign("/login"); }
  };

  const logout = () => {
    localStorage.removeItem("khn_token");
    localStorage.removeItem("khn_sa_token");
    try { sessionStorage.removeItem("khn_dismissed_reminders"); } catch { /* ignore */ }
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, impersonate, stopImpersonate }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
